import React from 'react';

// Page footer: the innovation band only. The blue sitemap footer was removed —
// navigation lives in the sidebar. HubPageLayout renders this inside the main
// column so its width matches the body rather than spanning the Report rail.
const DashboardFooter = () => (
  <div className="w-full mt-auto bg-white pt-10 pb-8">
    <h2 className="text-3xl xl:text-4xl text-black text-center mb-6">
      NuVola AI pushes the boundaries of innovation
    </h2>
    <img
      src="/images/innovation-brain.jpeg"
      alt="Analytical and creative sides of an illustrated brain"
      className="w-full max-h-[360px] object-cover block"
    />
    <div className="flex items-center gap-4 mt-8">
      <p className="text-xl text-black whitespace-nowrap">
        Information &raquo; Knowledge &raquo; Awareness
      </p>
      <div className="flex-1 border-t border-gray-400" />
    </div>
  </div>
);

export default DashboardFooter;
